import { useResponsive } from '@shared/utils/hooks/useResponsive';
import { useFeatureValue } from '@shared/core/featureFlags';
import type { FeatureFlagsState } from '@shared/core/featureFlags/featureFlags.types';

type MobileLayoutVariant = NonNullable<FeatureFlagsState['accommodationsListingEntryMobileLayoutV2']>;

export interface AccommodationsListingMobileLayoutState
  extends Readonly<{
    // True when screen < 768px (sm2 breakpoint). Matches the listing container's
    // flexDirection switch so JS layout predicates and CSS breakpoints stay aligned.
    isMobileOrTablet: boolean;
    variant: MobileLayoutVariant;
    shouldUseNewMobileLayout: boolean;
  }> {}

export const useAccommodationsListingMobileLayout = (): AccommodationsListingMobileLayoutState => {
  // No explicit initialValue — SSR default is derived from the User-Agent via DefaultMediaMatchProvider
  const [isMobileOrTablet = true] = useResponsive({ values: { _: true, sm2: false } });
  const featureFlag = useFeatureValue('accommodationsListingEntryMobileLayoutV2');

  const variant: MobileLayoutVariant = featureFlag.value || 'control';
  const shouldUseNewMobileLayout = isMobileOrTablet && (variant === 'treatment_clickable_card' || variant === 'treatment_cta_button');

  return {
    variant,
    isMobileOrTablet,
    shouldUseNewMobileLayout,
  };
};
